import * as React from "react";

import API from "../../../vendor/api";

interface ILastMessageProps {
    message: API.Message;
};

interface ILastMessageState {};

class LastMessage extends React.Component<ILastMessageProps, ILastMessageState> {
    public render(): JSX.Element {
        let message = this.props.message;
        return (
            <span>
                {message && message.text ? message.text : "Conteúdo não textual"}
            </span>
        );
    }
}

export default LastMessage;



// WEBPACK FOOTER //
// ./src/components/ChatList/LastMessage/index.tsx